var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"appContainer"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"mb-4 d-inline-block w-100 pt-2"},[_c('img',{staticClass:"logo-pagbrasil mt-2",attrs:{"src":require("@/assets/img/logos/pagbrasil.svg")}})]),_c('div',{staticClass:"w-100 mb-4 noprint boletonotfound"},[_vm._v(" Boleto não encontrado. ")])])])
}]

export { render, staticRenderFns }